@if (assistanceForm(); as assistanceFormGroup) {
  <form class="flex w-full flex-col gap-8" [formGroup]="assistanceFormGroup">
    <div>
      <div class="flex justify-between">
        <p class="font-bold">Was the patient admitted to hospital?</p>
        <p class="!text-xs text-gray-500">Optional</p>
      </div>
      <mat-radio-group
        class="mb-2 flex flex-col"
        formControlName="admittedToHospital"
      >
        @for (option of booleanOptions; track option.code) {
          <mat-radio-button class="mr-4" [value]="option.label">
            {{ booleanDisplay[option.code] }}
          </mat-radio-button>
        }
      </mat-radio-group>
      <pr-information-box>
        Patients who have been admitted to hospital will be contacted by ACC to
        determine if further rehabilitation assistance is required.
      </pr-information-box>
    </div>

    <div>
      <div class="flex justify-between">
        <p class="font-bold">Is further assistance required?</p>
        <p class="!text-xs text-gray-500">Optional</p>
      </div>
      <mat-radio-group
        class="mb-2 flex flex-col"
        formControlName="assistanceRequired"
      >
        @for (option of booleanOptions; track option.code) {
          <mat-radio-button class="mr-4" [value]="option.label">
            {{ booleanDisplay[option.code] }}
          </mat-radio-button>
        }
      </mat-radio-group>
      <p class="mt-2 !text-xs text-gray-500">
        Assistance other than primary treatment.
      </p>
    </div>

    <div>
      <div class="flex justify-between">
        <p class="font-bold">Should ACC contact you, the provider?</p>
        <p class="!text-xs text-gray-500">Optional</p>
      </div>
      <mat-radio-group
        class="mb-2 flex flex-col"
        formControlName="accContactProvider"
      >
        @for (option of rehabilitationOptions; track option.code) {
          <mat-radio-button class="mr-4" [value]="option.code">
            {{ rehabilitationDisplay[option.code] }}
          </mat-radio-button>
        }
      </mat-radio-group>
      <p class="mt-2 !text-xs text-gray-500">
        Please only select 'yes' if you would like an ACC case manager to call
        you about this patient.
      </p>
    </div>
  </form>
}

@if (referralForm(); as referralFormAGroup) {
  <form
    class="mt-8 flex w-full flex-col gap-8"
    [formGroup]="referralFormAGroup"
  >
    <div>
      <div class="flex justify-between">
        <p class="font-bold">Do you want to create a referral?</p>
        <p class="!text-xs text-gray-500">Optional</p>
      </div>
      <mat-radio-group
        class="mb-2 flex flex-col"
        formControlName="includeReferrals"
      >
        <mat-radio-button [value]="true">Yes</mat-radio-button>
        <mat-radio-button [value]="false">No</mat-radio-button>
      </mat-radio-group>

      <p class="mt-2 !text-xs text-gray-500">
        Up to five referrals can be added.
      </p>
    </div>

    @if (referralFormAGroup.controls.includeReferrals.value) {
      <div class="flex flex-col gap-4" formArrayName="referrals">
        @for (
          control of referralFormAGroup.referralControls;
          track idx;
          let idx = $index
        ) {
          <div
            class="flex flex-col gap-4 rounded bg-gray-50 p-4"
            [formGroupName]="idx"
          >
            <div class="flex justify-end">
              @if (idx > 0) {
                <button
                  mat-stroked-button
                  color="warn"
                  type="button"
                  [disabled]="disabled()"
                  (click)="referralFormAGroup.removeReferralForm($event, idx)"
                >
                  Remove
                </button>
              }
            </div>

            <mat-form-field class="w-full">
              <mat-label>Provider Type</mat-label>
              <mat-select formControlName="providerTypeCode" required>
                @for (option of providerTypeOptions; track option.code) {
                  <mat-option [value]="option.code">{{
                    option.label
                  }}</mat-option>
                }
              </mat-select>
              @if (control.providerTypeCodeRequiredError) {
                <mat-error>This field is required</mat-error>
              }
            </mat-form-field>

            <mat-form-field class="w-full">
              <mat-label>Referral Reason</mat-label>
              <textarea
                matInput
                formControlName="referralReason"
                rows="3"
              ></textarea>
              <mat-hint>
                Optional - provide details about why this referral is needed
              </mat-hint>
            </mat-form-field>
          </div>
        }

        @if (referralFormAGroup.referralControls.length < 5) {
          <div class="flex justify-end">
            <button
              mat-stroked-button
              color="primary"
              type="button"
              [disabled]="disabled()"
              (click)="referralFormAGroup.addReferralForm($event)"
            >
              <mat-icon>add</mat-icon>
              Add Referral
            </button>
          </div>
        }
      </div>
    }
  </form>
}
